module.exports = __webpack_public_path__ + "img/clothing163.19eff52d.jpg";